import React from 'react';

export default () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="27"
    height="24"
    viewBox="0 0 27 24"
  >
    <g fill="#46C3F1" fillRule="evenodd">
      <path d="M13.579 6.483v5.791l5.95 5.95 1.415-1.414-5.365-5.364V6.483z" />
      <path d="M23.065 3.515A11.92 11.92 0 0 0 14.58 0a11.919 11.919 0 0 0-8.485 3.515 11.924 11.924 0 0 0-3.233 5.93l-2.86-.308L0 9.162 3.58 12l4.1-2.012.004-.025L4.86 9.66a9.928 9.928 0 0 1 2.649-4.73A9.934 9.934 0 0 1 14.579 2a9.934 9.934 0 0 1 7.072 2.93A9.934 9.934 0 0 1 24.58 12a9.934 9.934 0 0 1-2.93 7.071 9.934 9.934 0 0 1-7.07 2.93 9.934 9.934 0 0 1-7.071-2.93l-1.414 1.414A11.919 11.919 0 0 0 14.58 24a11.92 11.92 0 0 0 8.485-3.515A11.919 11.919 0 0 0 26.58 12a11.92 11.92 0 0 0-3.515-8.485" />
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/icons/IconTime.jsx